import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

import { SiteLocale } from 'constants/i18n.constants';

import { hasWindow } from './browser.utils';
import { getDirection } from './i18n.utils';

const selectInsertionPoint = () => {
  if (!hasWindow()) return undefined;
  return (
    document.querySelector<HTMLMetaElement>(
      'meta[name="emotion-insertion-point"]',
    ) ?? undefined
  );
};

const cacheLtr = createCache({
  key: 'ltr',
  insertionPoint: selectInsertionPoint(),
});

const cacheRtl = createCache({
  key: 'rtl',
  stylisPlugins: [rtlPlugin],
  insertionPoint: selectInsertionPoint(),
});

// Select the correct cache client side
export const selectEmotionCache = (locale: SiteLocale) =>
  getDirection(locale) === 'rtl' ? cacheRtl : cacheLtr;

// Create a new cache for server side _document.tsx
export const createEmotionCache = (locale: SiteLocale) => {
  const direction = getDirection(locale);

  return createCache({
    key: direction,
    prepend: true,
    stylisPlugins: direction === 'rtl' ? [rtlPlugin] : [],
    insertionPoint: selectInsertionPoint(),
  });
};
